import React, {useEffect, useRef, useState} from 'react';
import "./home.css"
import Layout from "../../component/layout/layout";
import MainBox from "../../component/mainBox/mainBox";
import LatestContent from "../../component/latestContent/latestContent";
import Slider from "../../component/slider/slider";
import Line from "../../component/line/line";
import {toast} from 'react-toastify';
import Api from "../../services/api";
import mainImage from "../../res/img/main.jpg"
import {ENV} from "../../services/env"
import {useSelector} from "react-redux";
import ExperienceBox from "../../component/experienceBox/experienceBox";
const Home = () => {
    let installPromp
    const setting = useSelector(state => state.setting.setting )
    const [introductionList, setIntroductionList] = useState([])
    const [blogList, setBlogList] = useState([])
    const [galleryImageList, setGalleryImageList] = useState([])
    const [galleryVideoList, setGalleryVideoList] = useState([])
    const [bannerList, setBannerList] = useState([])
    const [experienceList, setExperienceList] = useState([])

    const mainTexts = setting && setting.main_information &&  JSON.parse(setting.main_information)

    // useEffect(() => {
    //         const mainText = document.querySelectorAll("#mainText")
    //         for (let i = 0; i < mainText.length; i++) {
    //             setTimeout(() => {
    //                 mainText && mainText[i].classList.add("get-in")
    //             }, 250 * i)
    //         }
    // } ,[mainTexts])

    useEffect(() => {

        introduction()
        getBlogData()
        getGallery()
        getBanner()
        getExperienceData()

    }, []);


    const introduction = () => {
        new Api().get("/introduction")
            .then((res) => {
                setIntroductionList(res)
            })
            .catch((err) => {
                toast.error(err)
            })
    }


    const getBlogData = () => {
        new Api().get("/blog?limit=4")
            .then((res) => {
                setBlogList(res)
            })
            .catch((err) => {
                toast.error(err)
            })
    }
    const getExperienceData = () => {
        new Api().get("/experience?limit=2")
            .then((res) => {
                setExperienceList(res)
            })
            .catch((err) => {
                toast.error(err)
            })
    }
    const getGallery = () => {
        new Api().get("/gallery/video?limit=3")
            .then((res) => {
                setGalleryVideoList(res)
            })
            .catch((err) => {
                toast.error(err)
            })
        new Api().get("/gallery/image?limit=3")
            .then((res) => {
                setGalleryImageList(res)
            })
            .catch((err) => {
                toast.error(err)
            })
    }
    const getBanner = () => {
        new Api().get("/banner")
            .then((res) => {
                setBannerList(res)
            })
            .catch((err) => {
                toast.error(err)
            })
    }
    return (
        <Layout>
            <div className={"main-top-box"}>
                <div className={"container"}>
                    <div className={"main-top-box-section"}>
                        <div className={"main-top-box-tex"}>
                            <ul>
                                <li>
                                    <h2  >{mainTexts && mainTexts[0]}</h2>
                                </li>
                                {
                                    mainTexts && mainTexts.map((item , index) => {
                                        return(
                                            index > 0 &&
                                            <li>
                                                <div className={"get-out"} id={"mainText"}>
                                                    <span>{item}</span></div>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                        <div className={"main-top-box-img"}>
                            <img src={ENV.API.IMG + (setting && setting.banner)}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className={"container"}>
                {
                    bannerList && bannerList.list && bannerList.list.length > 0 &&
                    <Slider type={"main"} list={bannerList}/>
                }
                {
                    setting && setting.file &&
                        <div>
                            <img src={ENV.API.IMG + (setting && setting.file)}/>
                        </div>
                }
                {galleryImageList && galleryImageList.length > 0 &&
                <>
                    <Line link={"/report-card"} title={"کارنامه ها"}/>
                    <div className={"gallery-main-box"}>
                        {
                            galleryImageList && galleryImageList.map((item) => {
                                return (
                                        <img src={ENV.API.IMG + item.file}/>
                                )
                            })
                        }
                    </div>
                </>
                }
                {experienceList && experienceList.length > 0 &&
                <>
                    <Line link={"/experience"} title={"تجربه زبان آموزان"}/>
                    <div className={"gallery-main-box"}>
                        {
                            experienceList && experienceList.map((item) => {
                                return(
                                    <ExperienceBox   route={"experience"} item={item}/>
                                )
                            })
                        }
                    </div>
                </>
                }
                {galleryVideoList && galleryVideoList.length > 0 &&
                <>
                    <Line link={"/gallery"} title={"ویديو های آموزشی"}/>
                    <div className={"gallery-main-box"}>
                        {
                            galleryVideoList && galleryVideoList.map((item) => {
                                return (
                                        <video loop muted playsinline preload="auto" controls>
                                            <source src={ENV.API.IMG + item.file + "#t=0.005"} type="video/mp4"/>
                                        </video>
                                )
                            })
                        }
                    </div>
                </>
                }
                {
                    introductionList && introductionList.list && introductionList.list.length > 0 &&
                    <>
                        <Line  link={"/introduction"}  title={"معرفی آموزشگاه و اساتید"}/>
                        <Slider type={"professor"} list={introductionList}/>
                    </>
                }
                {
                    blogList && blogList.length > 0 &&
                    <>
                        <Line link={"/blog"} title={" تازه ترین مطالب "}/>
                        <LatestContent list={blogList}/>
                    </>
                }

            </div>
        </Layout>
    );
};

export default Home;
